var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76251 0L4.06086 0.284447L0.525555 1.71754L0 1.93154L0.0162543 2.49773C0.0216724 2.67653 0.192342 6.94328 3.59491 10.6168C7.02998 14.3227 10.8416 14.7697 12.0932 14.916L12.1718 14.9241L12.803 15L13.0278 14.4067L14.4013 10.7874L14.6614 10.1047L14.0112 9.77424L10.1048 7.78851L9.56565 7.5149L9.14846 7.95376L7.82373 9.34892C7.27921 8.94256 6.3771 8.16506 5.52646 6.96766L6.8864 5.58334L7.29005 5.17428L7.03811 4.65685L5.09572 0.682677L4.76251 0Z",
    fill: "#153862"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.98f9d861dd557a7dcd619f51e8cec3c0.svg";
export { ForwardRef as ReactComponent };